/* ---- Imports ---- */

import { createRouter, createWebHistory } from 'vue-router'
import routes from './app'
import { useLoadingStore } from '@/stores/loading.js'
import { auth } from '@/firebaseConfig'

/* ---- Routes ---- */

/* ---- System ---- */

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

router.beforeEach(async (to, from, next) => {
  const loadingStore = useLoadingStore()
  
  if (to.name === 'mapa') {
    loadingStore.isLoading = false;
  }

  // Auth Check
  if (to.meta.requiresAuth) {
    const user = await new Promise(resolve => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            unsubscribe();
            resolve(user);
        });
        // Timeout de segurança de 4s caso o Firebase demore
        setTimeout(() => {
          resolve(auth.currentUser);
        }, 4000);
    });

    if (user) next();
    else next('/admin/login');
  } else {
    next();
  }
})

router.afterEach((to) => { document.title = to.meta.title })

export default router
